import { render } from "./NbsUserIcon.vue?vue&type=template&id=fb31af26&scoped=true"
const script = {}

import "./NbsUserIcon.vue?vue&type=style&index=0&id=fb31af26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb31af26"]])

export default __exports__